import React from "react"

import {Pagination} from "reactstrap"
import Link from "next/link";
import {FilterSelection} from "../types/filterSelection";

interface PaginationProps {
    pagination: any,
    searchSelection: FilterSelection
}

const PaginationLinkComponent = ({page, searchSelection}) => {
    const {urlPath, urlParams} = searchSelection.getPropertiesForLink();
    urlParams['pagina'] = page.number;

    return (
        <li className={page.isActive ? 'page-item active' : 'page-item'}>
            <Link
                href={{
                    pathname: urlPath,
                    query: urlParams,
                }}
                passHref
            >
                <a className="page-link">{page.number}</a>
            </Link>
        </li>
    )
}

const PaginationPreviousLinkComponent = ({pagination, searchSelection}) => {
    const {urlPath, urlParams} = searchSelection.getPropertiesForLink();
    urlParams['pagina'] = pagination.currentPage - 1;

    return (
        <li className={pagination.previousPageAvailable ? 'page-item previous' : 'page-item previous disabled'}>
            <Link
                href={{
                    pathname: urlPath,
                    query: urlParams,
                }}
                passHref
            >
                <a className="page-link">‹</a>
            </Link>
        </li>
    )
}

const PaginationNextLinkComponent = ({pagination, searchSelection}) => {
    const {urlPath, urlParams} = searchSelection.getPropertiesForLink();
    urlParams['pagina'] = pagination.currentPage + 1;

    return (
        <li className={pagination.nextPageAvailable ? 'page-item next' : 'page-item next disabled'}>
            <Link
                href={{
                    pathname: urlPath,
                    query: urlParams,
                }}
                passHref
            >
                <a className="page-link">›</a>
            </Link>
        </li>
    )
}

const PaginationFirstLinkComponent = ({pagination, searchSelection}) => {
    const {urlPath, urlParams} = searchSelection.getPropertiesForLink();
    urlParams['pagina'] = 1;

    return (
        <li className={pagination.previousPageAvailable ? 'page-item first' : 'page-item first disabled'}>
            <Link
                href={{
                    pathname: urlPath,
                    query: urlParams,
                }}
                passHref
            >
                <a className="page-link">
                    «
                </a>
            </Link>
        </li>
    )
}

const PaginationLastLinkComponent = ({pagination, searchSelection}) => {
    const pages = pagination.pages;
    const lastPage = pages[pages.length - 1];
    const {urlPath, urlParams} = searchSelection.getPropertiesForLink();
    urlParams['pagina'] = lastPage ? lastPage.number : 1;

    return (
        <li className={pagination.nextPageAvailable ? 'page-item last' : 'page-item last disabled'}>
            <Link
                href={{
                    pathname: urlPath,
                    query: urlParams,
                }}
                passHref
            >
                <a className="page-link">
                    »
                </a>
            </Link>
        </li>
    )
}

const PaginationComponent = ({pagination, searchSelection}: PaginationProps) => {
    return (
        <Pagination
            aria-label="Page navigation example"
            className="d-flex justify-content-center"
        >
            <PaginationFirstLinkComponent
                pagination={pagination}
                searchSelection={searchSelection}
            />
            <PaginationPreviousLinkComponent
                pagination={pagination}
                searchSelection={searchSelection}
            />
            {pagination.pages.map(page => (
                <PaginationLinkComponent
                    key={page.number}
                    page={page}
                    searchSelection={searchSelection}
                />
            ))}
            <PaginationNextLinkComponent
                pagination={pagination}
                searchSelection={searchSelection}
            />
            <PaginationLastLinkComponent
                pagination={pagination}
                searchSelection={searchSelection}
            />
        </Pagination>
    )
}

export default PaginationComponent
